import Button from 'react-bootstrap/Button';
import { formButtonStyle } from '../../styles';
import { handleOptionSelect } from '../../functions';

export default function SellRealEstate5({ setUserAnswers, navigate, location }) {
    return (
        <>
            <h2>Are you currently partnered with another listing agent?</h2>
            <Button
                style={formButtonStyle}
                variant="outline-primary"
                onClick={() =>
                    handleOptionSelect(navigate, location, setUserAnswers, "RealEstateAgentQuestion", "Yes")
                }
            >
                Yes
            </Button>
            <Button
                style={formButtonStyle}
                variant="outline-primary"
                onClick={() =>
                    handleOptionSelect(navigate, location, setUserAnswers, "RealEstateAgentQuestion", "No")
                }
            >
                No
            </Button>
            <Button
                style={formButtonStyle}
                variant="outline-primary"
                onClick={() =>
                    handleOptionSelect(navigate, location, setUserAnswers, "RealEstateAgentQuestion", "Multiple")
                }
            >
                I'm interviewing multiple agents
            </Button>
        </>
    );
}